export function getHostname(host = '') {
  try {
    const url = new URL(host);
    return url.hostname || url.href;
  } catch (e) {
    return '';
  }
}
